import {create} from 'zustand'

export interface AvatarFunction {
  key: string
  label: string | React.ReactNode
}

interface GlobalStoreState {
  headerStyle: 'system' | 'custom'
  setHeaderStyle: (value: 'system' | 'custom') => void

  currentSubAppKey: string
  setCurrentSubAppKey: (value: string) => void

  subAppAvatarFunctions: AvatarFunction[]
  setSubAppAvatarFunctions: (value: AvatarFunction[]) => void
}

export default create<GlobalStoreState>((set)=>({
  headerStyle: 'system',
  setHeaderStyle: (value: 'system' | 'custom') => set({headerStyle: value}),

  currentSubAppKey: '',
  setCurrentSubAppKey: (value: string) => set({currentSubAppKey: value}),

  subAppAvatarFunctions: [],
  setSubAppAvatarFunctions: (value: AvatarFunction[]) => set({subAppAvatarFunctions: value})
}))